import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["toggleLink"];

  toggle() {
    this.toggleLinkTarget.classList.toggle("loop--disabled");
  }
}
